/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleQueryReportType extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ScheduleQueryReportType");
    }

    getFixupPrototypeFunction() { return ScheduleQueryReportType.fixupPrototype; }

    static newInstance(model: Partial<ScheduleQueryReportType>): ScheduleQueryReportType {
        let obj = Object.assign(new ScheduleQueryReportType(), model);
        ScheduleQueryReportType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleQueryReportType>): ScheduleQueryReportType {
        if (!model) return null;
        return ScheduleQueryReportType.newInstance(<ScheduleQueryReportType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleQueryReportType) {
        if (!obj) return;

        models.ScheduleQueryReportType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleQueryReportType): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleQueryReportType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Report Type of the Schedule for category reports
     */
    report_types: Array<models.WellArchitectedFrameworkAssessmentRunReportType>;

}
